import React, {Component} from 'react';
import {Area, AreaChart, CartesianGrid, ReferenceLine, ResponsiveContainer, Tooltip, XAxis, YAxis} from 'recharts';

class AreaChartGraph extends Component {

  formatTick = (tick) => {
    return tick.replace(' 12:00 AM', '');
  };

  render() {
    const { data, ticks, graph, now_x, selected_time_x, onGraphClick } = this.props;
    return <ResponsiveContainer width="100%" height={200}>
      <AreaChart data={data}
                 margin={{ top: 5, right: 30, left: 20, bottom: 20 }}
                 onClick={onGraphClick.bind(null, data)}>
        <CartesianGrid strokeDasharray="3 3"/>
        <XAxis dataKey="name"
               tick={{ angle: 0, fontSize: 11 }}
               textAnchor="start"
               ticks={ticks}
               tickFormatter={this.formatTick}
               interval={0}/>
        {graph.YAxisTicks && graph.YAxisTicks.length > 0 &&
         <YAxis tick={{ fontSize: 11 }}
                ticks={graph.YAxisTicks}
                tickCount={graph.YAxisTicks ? graph.YAxisTicks.length : 5}
                interval={0}
                label={{ value: graph.YAxisLabel, angle: -90, position: 'insideLeft', fontSize: 12 }}/>
        }
        {!graph.YAxisTicks &&
         <YAxis tick={{ fontSize: 11 }}
                label={{ value: graph.YAxisLabel, angle: -90, position: 'insideLeft', fontSize: 12 }}/>
        }
        <Tooltip/>
        <ReferenceLine x={now_x}
                       stroke="red"/>
        <ReferenceLine x={selected_time_x}
                       stroke="red"
                       strokeDasharray="3 3"/>
        {
          graph.thresholds.map((threshold, i) => (
            <ReferenceLine key={i}
                           y={threshold.value}
                           label={threshold.label}
                           stroke={threshold.stroke}
                           strokeDasharray={threshold.strokeDasharray}/>
          ))
        }
        {
          graph.series.map((area, i) => (
            <Area key={i}
                  type={area.type}
                  dataKey={area.dataKey}
                  stroke={area.stroke}
                  fill={area.fill}/>
          ))
        }
      </AreaChart>
    </ResponsiveContainer>;
  }
}

export default AreaChartGraph;



// WEBPACK FOOTER //
// ./src/components/graphs/AreaChartGraph.js